import React from "react";
import { FunkoFunBackground } from "../../components";
import { InputAdminPassword } from "./components";
import { useLoginForm, useHandlers } from "./hooks";
import FormContext from "../../context/formContext";
import { Button } from "../../components";
import "./index.scss";

/**
 * @desc Login Page.
 */
const Login = () => {
  // CONSTANTS ----------------------------------------------------------------

  const {
    control,
    handleSubmit,
    formState: { isSubmitting, isValid },
    setError,
  } = useLoginForm();

  // HANDLERS -----------------------------------------------------------------

  const { handleKeyUp, onSubmit } = useHandlers({ setError, handleSubmit });

  // COMPONENT ----------------------------------------------------------------

  const context = {
    control,
  };

  const inputProps = {
    onKeyUp: handleKeyUp,
    autoComplete: "off",
    fieldName: "password",
  };

  const buttonProps = {
    onClick: handleSubmit(onSubmit),
    disabled: isSubmitting || !isValid,
    children: "Login",
  };

  return (
    <FormContext.Provider value={context}>
      <FunkoFunBackground title={"Convention Tracker Admin"}>
        <div className="login page-container">
          <div className="card">
            <h1 className="header">Convention Tracker Admin</h1>
            <div className="input-container">
              <InputAdminPassword {...inputProps} />
            </div>
          </div>
          <Button {...buttonProps} />
        </div>
      </FunkoFunBackground>
    </FormContext.Provider>
  );
};

export default Login;
